import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  ListSubheader,
} from "@mui/material";

function CustomSelectWithHeaders({
  disabled,
  name,
  value,
  onChange,
  error,
  helperText,
  sx = {},
  options,
  label,
  MenuProps,
  fullWidth = true,
  required,
  size = true,
}) {
  const sizeStyles =
    size === "small"
      ? {
          "& .MuiInputBase-root": { height: "36px" },
          "& .MuiSelect-select": {
            paddingTop: "10px",
            paddingBottom: "10px",
            boxSizing: "border-box",
          },
          "& .MuiInputLabel-root": {
            transform: "translate(14px, 9px) scale(1)",
          },
          "& .MuiInputLabel-shrink": {
            transform: "translate(14px, -6px) scale(0.75)",
          },
        }
      : {};

  return (
    <FormControl
      size="small"
      fullWidth={fullWidth}
      disabled={disabled}
      error={Boolean(error)}
      sx={{ ...sx, ...sizeStyles }}
      variant="outlined"
    >
      {label && (
        <InputLabel id={`${name}-label`}>
          {required ? `${label} *` : label}
        </InputLabel>
      )}
      <Select
        labelId={`${name}-label`}
        label={label}
        fullWidth={fullWidth}
        name={name}
        onChange={onChange}
        value={value}
        MenuProps={MenuProps}
        sx={sizeStyles}
      >
        {options?.map((group, gIndex) => {
          if (group.options) {
            // It's a group with header
            return [
              <ListSubheader key={`header-${gIndex}`}>
                {group.label}
              </ListSubheader>,
              group.options.map((opt, index) => (
                <MenuItem key={`${gIndex}-${index}`} value={opt.value}>
                  {opt.label}
                </MenuItem>
              )),
            ];
          }
          // fallback: single flat option
          return (
            <MenuItem key={gIndex} value={group.value}>
              {group.label}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && (
        <FormHelperText error={Boolean(error)}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export default CustomSelectWithHeaders;
